import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from 'moment';
import { withTranslation } from "react-i18next";
import CountdownComponentCard from "../CountdownComponentCard";
import { useState, useEffect } from "react";

function ProvCardIsTodayCita({ t, item, serverTime, setServerTime, clientTime, setClientTime }) {
    const { patientDTO } = item;
    const [isConsultaIniciada, setIsConsultaIniciada] = useState(false);

    useEffect(() => {
        // Aquí vamos a controlar si la consulta ya comenzó o si el contador llegó a 0
        const consultaInicio = moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").toDate();
        const now = new Date();
        if (now >= consultaInicio) {
            setIsConsultaIniciada(true);
        }
    }, [item.scheduleDTO.dateTimeInit]);

    return (
        <Card className="shadow-1 border-red">
            <Card.Body>
                <h6 className="color-red text-uppercase">
                    <CountdownComponentCard
                        date={moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").toDate()}
                        serverTime={serverTime}
                        setServerTime={setServerTime}
                        clientTime={clientTime}
                        setClientTime={setClientTime}
                        onComplete={() => setIsConsultaIniciada(true)} // Cuando el contador llegue a 0
                    />
                </h6>

                <strong>{patientDTO.name ? `${patientDTO.name} ${patientDTO.middleName ?? ''} ${patientDTO.lastName} ${patientDTO.seccondSurname ?? ''}` : ''}</strong>

                <small className="d-block color-7F8FA4">{item.speciality.name}</small>

                <div className="mt-2">
                    <small className="d-block color-7F8FA4">Hora</small>
                    <small className="d-block">{moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}</small>
                </div>

                <hr />

                <div className="d-flex justify-content-between">
                    <div>
                        {/* <small className="d-block color-red">Cambiar cita</small> */}
                    </div>
                    <div>
                        {/* Solo mostrar el Link si la consulta ya ha comenzado o el contador ha llegado a 0 */}
                        {(isConsultaIniciada || serverTime >= moment(item.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").toDate()) && (
                            <Link to={`${item.externalUrl ? `/admin/proveedor/citacliente/${btoa(item.id)}` : `/admin/proveedor/conferencia/${btoa(item.id)}`}`} className="no-underline">
                                <small className="d-block color-green">Iniciar consulta</small>
                            </Link>
                        )}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default withTranslation()(ProvCardIsTodayCita);